import { useContext, useState, useEffect } from 'react'
import { IntakeContext } from '../context/IntakeContext'

import { IconButton, Tooltip, Fade, Box, Grid, Typography } from '@mui/material'
import HelpIcon from '@mui/icons-material/Help'

import { format, subYears, differenceInYears } from 'date-fns'
import { renderMuiFormField } from 'utils/forms/renderMuiFormField'
import CompanySearchAutocomplete from './CompanySearchAutocomplete'
import { useFormDebounce } from 'hooks/useFormDebounce'
import { useFieldFocus } from 'context/FieldFocusContext'

const OnboardingMultiQuestion = ({
  preHeader,
  header,
  subHeader,
  helpText,
  questionArray,
  alternateInput,
  handleNext,
}) => {
  const { intakeState, updateIntakeStateAtKey } = useContext(IntakeContext)
  const { updateIntakeStateAndSubmit } = useFormDebounce()
  const [altQuestion, setAltQuestion] = useState(true)

  const dateToYears = intakeState?.dateOfBirth
    ? differenceInYears(new Date(), new Date(intakeState?.dateOfBirth))
    : ''
  const yearsToDate = (years) =>
    format(subYears(new Date(), years), 'yyyy-MM-dd')

  const [isMobile, setIsMobile] = useState(window.innerWidth < 992)
  const fieldId = 'headerHelp'
  const { handleFocus, handleBlur, registerHelpField } = useFieldFocus()
  useEffect(() => {
    registerHelpField(fieldId, helpText)
  }, [fieldId])

  const fieldMap = (data) => {
    return (
      <Grid container spacing={2} mt={0}>
        {data.map((question) => (
          <Grid
            item
            key={question.id}
            xs={12}
            mb={2}
            sx={{ display: question.hiddenField ? 'none' : 'block' }}
          >
            {question.id === 'employerName' ? (
              <CompanySearchAutocomplete
                onChange={(value) =>
                  updateIntakeStateAtKey({ employerDetails: value })
                }
                enableHelpText={question.enableHelpText}
                helpText={question.helpText}
                id={question.id}
                name={question.id}
                onFocus={(e) => handleFocus(question.id, e.target)}
                onBlur={handleBlur}
                onMouseEnter={(e) => handleFocus(question.id, e.currentTarget)}
                onMouseLeave={() => handleBlur()}
              />
            ) : (
              <>
                {question.inputType === 'splitdate' && (
                  <Box mb={2}>
                    <Typography variant="body1Medium">
                      {question.label}
                    </Typography>
                  </Box>
                )}
                {renderMuiFormField({
                  handleNext,
                  autoFocus: false,
                  id: question.id,
                  label:
                    question.inputType === 'splitdate' ? '' : question.label,
                  required: question.required,
                  placeholder: question.placeholder,
                  inputType: question.inputType,
                  options: question.options,
                  value: intakeState?.[question.id],
                  defaultDate: question?.defaultDate || '1980-01-01',
                  onChange: (value) =>
                    updateIntakeStateAtKey({
                      [question.id]: value,
                    }),
                  enableHelpText: !!question.helpText,
                  helpText: question.helpText,
                })}
              </>
            )}
          </Grid>
        ))}
      </Grid>
    )
  }

  return (
    <Box sx={{ textAlign: 'left' }}>
      <Box
        onMouseEnter={(e) => handleFocus(fieldId, e.currentTarget)}
        onMouseLeave={() => handleBlur()}
      >
        <Box>
          <Typography variant="subtitle1" fontSize={{ xs: '16px', sm: '20px' }}>
            {preHeader || ''}
          </Typography>
        </Box>
        <Box mb={1}>
          <Typography variant="h4" fontSize={{ xs: '20px', sm: '24px' }}>
            {header || "Let's start with your basic information:"}
            {helpText !== '' && isMobile && (
              <Tooltip
                TransitionComponent={Fade}
                title={
                  helpText || 'This helps us calculate your retirement benefits'
                }
                placement="top"
                color="info"
                enterTouchDelay={0}
                leaveTouchDelay={3000}
              >
                <IconButton size="small" color="dark">
                  <HelpIcon sx={{ marginTop: '-10px' }} />
                </IconButton>
              </Tooltip>
            )}
          </Typography>
        </Box>
        <Typography
          variant="body1"
          sx={{ lineHeight: '1.4' }}
          fontSize={{ xs: '16px', sm: '20px' }}
        >
          {subHeader ||
            'Let us know your name and other basic details about you!'}
        </Typography>
      </Box>

      <Box pt={1}>
        {fieldMap(questionArray)}
        {alternateInput && <div>Alt Input Exists</div>}
      </Box>
    </Box>
  )
}

export default OnboardingMultiQuestion
